import React, { useState } from "react";
import DrawerComponent from "./Card/Drawer";
import PageLoader from "../../components/loader/PageLoader";
import "./Card/index.css";

const DataDisplay = ({
  isLoad,
  isNotFound,
  data,
  isItemSelected,
  biomarkerData,
  handleAdd,
  handleRemove,
  selectedServiceType,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedBiomarker, setSelectedBiomarker] = useState(null);
  const [expandedIds, setExpandedIds] = useState({});

  const closeDrawer = () => {
    setDrawerOpen(false);
    setSelectedBiomarker(null);
    document.body.style.overflow = "auto";
  };

  const handleBiomarkerClick = (item) => {
    const biomarkersToShow =
      item.type === "biomarker" ? [item._id] : item.biomarkers;
    const fetchedBiomarkers = biomarkerData.filter((biomarker) =>
      biomarkersToShow.includes(biomarker._id)
    );
    setSelectedBiomarker(fetchedBiomarkers);
    setDrawerOpen(true);
    document.body.style.overflow = "hidden";
  };

  const toggleDescription = (id) => {
    setExpandedIds((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getDescriptionPreview = (text, limit = 140) => {
    if (typeof text !== "string") {
      return { preview: "", needsMore: false };
    }
    const trimmed = text.trim();
    if (trimmed.length <= limit) {
      return { preview: trimmed, needsMore: false };
    }
    let truncated = trimmed.slice(0, limit);
    const lastSpace = truncated.lastIndexOf(" ");
    if (lastSpace !== -1) {
      truncated = truncated.slice(0, lastSpace);
    }
    return { preview: truncated, needsMore: true };
  };

  return (
    <div className="mt-10 mt-lg-0">
      <div className="row loader-single-cards g-lg-8 g-5">
        {isLoad && (
          <div className="col-md-12 text-center" style={{ marginTop: "50px" }}>
            <PageLoader />
          </div>
        )}
        {!isLoad &&
          data &&
          data.length > 0 &&
          data.map((item) => {
            const isSelected = isItemSelected(item._id);
            const isProfile = item.type === "profile";
            const biomarkerCount =
              item.type === "biomarker" ? 1 : item.biomarkers?.length || 0;
            const fullDescription = (item.shortDescription || "").trim();
            const { preview, needsMore } = getDescriptionPreview(fullDescription);
            const isExpanded = !!expandedIds[item._id];

            return (
              <div className="col-lg-4 col-md-6" key={item._id}>
                <div
                  className={`bmp-item-card ${
                    isProfile ? "bmp-item-card--profile" : "bmp-item-card--biomarker"
                  } ${isSelected ? "is-selected" : ""}`}
                >
                  <h6 className="bmp-item-card__title" title={item.name}>
                    {item.name}
                  </h6>
                  <p className={`bmp-item-card__desc ${isExpanded ? "is-expanded" : ""}`}>
                    {isExpanded ? fullDescription : preview}
                    {needsMore && (
                      <>
                        {" "}
                        <button
                          type="button"
                          className="bmp-item-card__more"
                          onClick={() => toggleDescription(item._id)}
                        >
                          {isExpanded ? "less" : "more"}
                        </button>
                      </>
                    )}
                  </p>
                  <div className="bmp-item-card__footer">
                    <button
                      type="button"
                      className="bmp-item-card__meta"
                      onClick={() =>
                        handleBiomarkerClick(item, selectedServiceType)
                      }
                    >
                      <span className="bmp-item-card__count">{biomarkerCount}</span>
                      Biomarker analysed
                    </button>
                    {isSelected ? (
                      <button
                        type="button"
                        className={`${
                          isProfile ? "btn-green active" : "btn-show active"
                        } bmp-item-card__action`}
                        onClick={() => handleRemove(item._id)}
                      >
                        Remove
                      </button>
                    ) : (
                      <button
                        type="button"
                        className={`${
                          isProfile ? "btn-green" : "btn-show"
                        } bmp-item-card__action`}
                        onClick={() => handleAdd(item._id, item.type)}
                      >
                        Add
                      </button>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        {isNotFound && (
          <div className="col-12 text-center">
            <h4 className="fw-normal">OOPS!</h4>
            <p className="fw-normal ">
              No results found. Alternatively, kindly check the spelling.{" "}
            </p>
          </div>
        )}
      </div>

      <DrawerComponent
        isOpen={drawerOpen}
        onClose={closeDrawer}
        biomarkerData={selectedBiomarker}
      />
    </div>
  );
};

export default DataDisplay;
